import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation/dist/localization/messages_ru';

import {goAjaxForm} from '../common/ajax-form';

const login = ($form) => {
    if ($form.length) {
        goAjaxForm({
            $form: $form,
            onSuccess: () => window.location.reload(),
            scroll: false,
            show_msg_ok: false});
    }
};

$(function () {
    const $form = $('#id_form_sign_in');
    if ($form.length) {
        $form.validate();
        login($form);
    }
});



// WEBPACK FOOTER //
// ./js/accounts/login.js